import { createContext } from 'react'

import { createCrudFormStore } from '../store/createStore'

export const CrudFormStoreContext = createContext<
  ReturnType<typeof createCrudFormStore> | undefined
>(undefined)
